export default [
    {
        label: 'Country/Region',
        value: 'country_region',
        options: [],
    },
    {
        label: 'Sectors',
        value: 'sectors',
        options: [],
    },
    {
        label: 'Position types',
        value: 'position_types',
        options: [],
    },
];

export const companyFilterLabels = {
    countries: 'Country',
    tags: 'Sectors',
    job_types: 'Job Type',
};
